(ns frontend.test.url-input
  (:require [frontend.routing :as routing]
            [basic-components.inputs.footprint :refer [editor viewer]]
            [basic-components.field-editor :as field-editor]
            [reagent.core :as r]))


(defmethod routing/render-view :test/url-input [{:keys [route-params]}]
  (let [state (r/atom {})]
    [:div.container.py-4.bg-white.scroll
     [:h1.title-h1.mb-4 "URL input"]
     [:h2.title-h2.mt-4.mb-2 "URL input"]
     [:span "An url input can defines a field for entering a URL."]

     [:h3.title-h3.my-3 "Read mode"]
     [viewer {:editor/type :editor.type/url
              :value       "www.zapflow.com"}]

     [:h4.title-h3.mt-4.mb-3 "Field Editor mode"]
     [field-editor/view
      {:editor/type         :editor.type/url
       :value               (:value @state)
       :state-atom          state
       :attribute           :test-textarea-attribute
       :label               "url"
       :hide-label?         false
       :on-save!            (fn [v]
                              (swap! state assoc :value v))
       :class-name          ""
       :mandatory?          true
       :drag-options        nil
       :validate!           (fn []
                              true)
       :disabled?           false
       :read-only?          false
       :info-text           "Info url"
       :error-text          "Test error text"
       :tools               [:tool-item/copy
                             :tool-item/edit
                             :tool-item/open-url
                             :tool-item/cancel]
       :secondary-view-args nil}]]

    ))
